const TiposMutationCliente = {
    SET_CLIENTE_ATUAL: "SET_CLIENTE_ATUAL",
};

Object.freeze(TiposMutationCliente);

export default TiposMutationCliente;
